import React, { Component } from 'react';
import StockGrid from './StockGrid.js';
import Character from './Character.js';
import { calcX } from './SVGUtils.js';

const gameDataJSON = require('./data/new_format.json');

class GameView extends Component {
    static defaultProps = {
        flipPortraits:false,
        width:1920,
        minWidth: 600,
        yPadding:30,
        xPadding:90,
        yGrid:90,
        gameData:gameDataJSON,
        compressedStocks:true,
        compressedTime:true
    };

    constructor(props){
        super(props);

        this.state = {s:0, focused:null, scrollOffset:0, hoverX:-1, showLag:false, playerFocused:null};
        this.hover = this.hover.bind(this);
        this.getPercentFromSecond = this.getPercentFromSecond.bind(this);
        this.getScoreFromSecond = this.getScoreFromSecond.bind(this);
        this.toggleLag = this.toggleLag.bind(this);
        this.setPlayerFocus = this.setPlayerFocus.bind(this);

        this.updatePercents(props);
    }

    componentWillReceiveProps(nextProps) {
        this.updatePercents(nextProps);
    }

    componentDidUpdate() {
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    toggleLag() {
        this.setState({showLag:!this.state.showLag});
    }

    updatePercents(props) {
        let percentsBySecond = {};

        for (let playerI=0; playerI < props.gameData.percents.length; playerI++) {
            let player = props.gameData.percents[playerI];
            let lastTime = 0;
            let lastPercent = -1;

            percentsBySecond[playerI] = [];

            for (let i=0; i<player.length; i++) {
                for (let j=0; j<player[i].length; j++) {
                    if (player[i][j][0] !== lastPercent) {
                        for (let k=lastTime; k<Math.ceil(player[i][j][1]); k++) {
                            percentsBySecond[playerI][k] = lastPercent;
                        }
                        lastTime = parseInt(player[i][j][1], 10);
                        lastPercent = player[i][j][0];
                    }
                }
            }
        }

        this.state.percentsBySecond = percentsBySecond;
        // does not currently extend to last percents
    }

    setPlayerFocus (player) {
        this.setState({playerFocused:player});
    }

    onMouseScroll(e) {
        //this.setState({scrollOffset:(this.state.scrollOffset - 10*e.deltaY)});
        //e.preventDefault();
    }

    clicked() {
        this.setState({s:(this.state.s+1)%4});
    }

    stockLossIcon(x, y, size, color) {
        let offset = "translate(" + x + ", " + y + ")";
        return (
            <g key={"stock-loss-icon-" + x + "-" + y} transform={offset}>
              <line className={color} x1="0" x2={size} y1="0" y2={size} />
              <line className={color} x1={size} x2="0" y1="0" y2={size} />
            </g>
        );
    }


    hover(e) {
        let x = e.clientX-49;// - e.target.getBoundingClientRect().left;
        this.setState({hoverX:x});
    }

    getPercentFromSecond(player, seconds) {
        if (this.state.percentsBySecond) {
            let s = parseInt(seconds, 10);
            if (s < this.state.percentsBySecond[player].length) {
                return this.state.percentsBySecond[player][s];
            } else {
                return this.state.percentsBySecond[player][this.state.percentsBySecond[player].length-1];
            }
        }
        return -1;
    }

    getScoreFromSecond(player, seconds) {
        if(Object.keys(this.props.gameData.characters).length === 2) {
            let playerStocks = 2;

            for (let i=0; i<this.props.gameData["all_kills"].length; i++) {
                let kill = this.props.gameData["all_kills"][i];

                if(kill["time"] > seconds) {
                    break;
                }

                if (kill["target"] === player) {
                    playerStocks -= 1;
                }
            }
            return playerStocks;
        } else {
            // 4 player, show score
            let scores = [0, 0, 0, 0];
            for (let i=0; i<this.props.gameData["all_kills"].length; i++) {
                let kill = this.props.gameData["all_kills"][i];

                if(kill["time"] > seconds) {
                    break;
                }

                scores[kill["target"]] -= 1;
                scores[kill["killer"]] += 1;
            }
            let sign = scores[player] >= 0 ? "+" : "";
            return sign + scores[player];
        }
    }

    render() {
        let gameData = this.props.gameData;
        let maxPercent = 200;
        let numGrids = maxPercent/100;
        let yGrid = this.props.yGrid;
        let gridHeight = yGrid*numGrids;
        let w = this.props.width;
        let fullWidth = 1920;
        let stocks = this.props.compressedStocks ? 1 : 2;


        let minW = this.props.minWidth;
        let numCharacters = Object.keys(gameData.characters).length;


        let colors = numCharacters === 2? ["p1", "p2"] : ["ts-p1", "ts-p2", "ts-p3", "ts-p4"];

        // let xscale = 1920.0/120.0;
        let minutes = numCharacters === 2 ? 5 : 2;
        let xscale = 1920.0/(minutes*60);

        if (this.props.compressedTime) {
            xscale = 1920.0 / gameData.length;
        }

        let viewBox = "0 0 " + (this.props.width + this.props.xPadding*2) + " " + (numGrids*stocks*yGrid + this.props.yPadding*2);

        let percentData = gameData.percents.map(function(players, i) {
            let lastX = 0;
            let lastY = 0;
            let playerPercentLines = players.map(function(stock, j) {
                let lines = stock.map(function(percent, k) {
                    let stockOffset = this.props.compressedStocks ? 0 : j*gridHeight;
                    let lineClass = k === 0 ? colors[i] + " stock" : colors[i];
                    let lines = [];
                    let newY = gridHeight*stocks-(percent[0]/maxPercent * gridHeight)-stockOffset;

                    lines.push(<line key={i + "horz" + j} className={colors[i]} x1={calcX(lastX*xscale, w, fullWidth, minW)} x2={calcX(percent[1]*xscale, w, fullWidth, minW)} y1={lastY} y2={lastY} />);
                    lines.push(<line key={i + "vert" + j} className={lineClass} x1={calcX(percent[1]*xscale, w, fullWidth, minW)} x2={calcX(percent[1]*xscale, w, fullWidth, minW)} y1={lastY} y2={newY} />);
                    lastX = percent[1];
                    lastY = newY;

                    // first stock should not have a line from 0, 0
                    if(k === 0 && j === 0) {
                        return null;
                    }

                    return lines;
                }, this);
                return lines;
            }, this);

            let fade = "";

            if (this.state.playerFocused !== null) {
                fade = i === this.state.playerFocused ? "" : "faded";
            }

            return <g key={"percentLine" + i} className={fade}>{playerPercentLines}</g>;
        }, this);

        let falls = gameData.falls.map(function(player, i) {
            return player.map(function(fall, j) {
                let lines = [];
                let percent = fall['fall_percent'];
                let time = fall['time'];
                let py = 0;
                if (percent !== 0) {
                    if(this.props.compressedStocks) {
                        py = gridHeight - (percent / maxPercent * gridHeight);
                    } else {
                        py = gridHeight*stocks - (percent / maxPercent * gridHeight) - j*gridHeight;
                    }
                    lines.push(this.stockLossIcon(calcX(time*xscale, w, fullWidth, minW), py-10, 20, colors[fall["killer"]]));
                    lines.push(<text key={"fall-ij-" + i + "-" + j} fill="#555" fontSize="19" fontWeight="600" x={calcX(time*xscale+25, w, fullWidth, minW)} y={py+10}>{percent}%</text>);
                }
                return lines;
            }, this);
        }, this);

        let charPortraits = [];
        if (this.props.flipPortraits) {
            if(numCharacters > 2) {
                charPortraits.push(<Character key="p1-char" character={gameData.characters[2][0]} alt={gameData.characters[2][1]} team="blue" x="0" y="0" size={75}/>);
                charPortraits.push(<Character key="p2-char" character={gameData.characters[3][0]} alt={gameData.characters[3][1]} team="blue" x={78} y="0" size={75}/>);
                charPortraits.push(<text key="vs-label" x="163" y="45" fontWeight="800">vs</text>);
                charPortraits.push(<Character key="p3-char" character={gameData.characters[0][0]} alt={gameData.characters[0][1]} team="red" x={78*2+40} y="0" size={75}/>);
                charPortraits.push(<Character key="p4-char" character={gameData.characters[1][0]} alt={gameData.characters[1][1]} team="red" x={78*3+40} y="0" size={75}/>);
            } else {
                charPortraits.push(<Character key="p1-char" character={gameData.characters[0][0]} alt={gameData.characters[0][1]} team="red" x={75+40} y="0" size={75}/>);
                charPortraits.push(<text key="vs-label" x="85" y="45" fontWeight="800">vs</text>);
                charPortraits.push(<Character key="p2-char" character={gameData.characters[1][0]} alt={gameData.characters[1][1]} team="blue" x="0" y="0" size={75}/>);
            }
        } else {
            charPortraits.push(<Character key="p1-char" character={gameData.characters[0][0]} alt={gameData.characters[0][1]} team="red" x="0" y="0" size={75}/>);
            charPortraits.push(<text key="vs-label" x="85" y="45" fontWeight="800">vs</text>);
            charPortraits.push(<Character key="p2-char" character={gameData.characters[1][0]} alt={gameData.characters[1][1]} team="blue" x={75+40} y="0" size={75}/>);
        }

        let length = gameData.length;
        let mouseX = this.state.hoverX;

        let setRef = c => this.mySVG = c; // stored as a function to fix formatting

        let lag = [];
        for (let i=0; i<gameData["lag_spikes"].length; i++) {
            let lagSpike = gameData["lag_spikes"][i];
            if (lagSpike[1] < gameData.length-0.3) {
                let x = calcX(lagSpike[1]*xscale, w, fullWidth, minW);
                let lagLength = calcX(lagSpike[0]*xscale*8, w, fullWidth, minW);
                lag.push(<rect className="lag" x={x} y={0} width={lagLength} height={yGrid*2} />);
            }
        }

        let controlButtons = [];
        if (numCharacters === 4) {
            controlButtons.push(<button key="p1-button" onClick={() => this.setPlayerFocus(2)}>P1</button>);
            controlButtons.push(<button key="p2-button" onClick={() => this.setPlayerFocus(3)}>P2</button>);
            controlButtons.push(<button key="p3-button" onClick={() => this.setPlayerFocus(0)}>P3</button>);
            controlButtons.push(<button key="p4-button" onClick={() => this.setPlayerFocus(1)}>P4</button>);
        } else {
            controlButtons.push(<button key="p1-button" onClick={() => this.setPlayerFocus(1)}>P1</button>);
            controlButtons.push(<button key="p2-button" onClick={() => this.setPlayerFocus(0)}>P2</button>);
        }

        controlButtons.push(<button key="all-button" onClick={() => this.setPlayerFocus(null)}>ALL</button>);


        return (
            <div className="GameView" onWheel={this.onMouseScroll.bind(this)}>
              <svg viewBox={viewBox} ref={setRef}>
                <StockGrid width={this.props.width}
                           length={gameData.length}
                           minWidth={this.props.minWidth}
                           padding={this.props.padding}
                           maxPercent={maxPercent}
                           stocks={this.props.compressedStocks ? 1 : stocks}
                           yGrid={yGrid}
                           scrollOffset={this.state.scrollOffset}
                           hoverX={mouseX}
                           getPercent={this.getPercentFromSecond}
                           getScore={this.getScoreFromSecond}
                           characters={numCharacters}
                           minutes={minutes}
                           compressedTime={this.props.compressedTime} >
                  {this.state.showLag && lag}
                  <line key="game-end" className="game-end" x1={calcX(length*xscale, w, fullWidth, minW)} x2={calcX(length*xscale, w, fullWidth, minW)} y1={0} y2={gridHeight*stocks} />
                  { falls }
                  { percentData }

                  <g key="char-portraits-group" transform="translate(70, 8)">
                    {charPortraits}
                  </g>
                </StockGrid>
              </svg>
              <div className="for-hover" onMouseMove={this.hover}>
                { gameData["has_lag_data"] && <button onClick={this.toggleLag}>{this.state.showLag ? "Hide" : "Show"} Lag</button>}
                {controlButtons}
              </div>

            </div>
        );
    }
}

export default GameView;

